import { configureStore, Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import { hallmapReducer } from 'entities/hallmap/model/hallmapSlice';
import { ordersReducer } from 'entities/orders';
import { personReducer } from 'entities/person';
import { settingsReducer } from 'entities/settings';
import { tagsReducer } from 'entities/tags';
import { placesReducer } from 'entities/toolbar/places/model/placesSlice';
import { timeslotsReducer } from 'entities/toolbar/timeslots';
import { authReducer } from 'entities/user/auth/model/authSlice';

const loggerMiddleware =
	(store: MiddlewareAPI) => (next: unknown) => (action: unknown) => {
		console.log('Текущее состояние:', store.getState());
		console.log('Выполняемое действие:', action);
		if (typeof next === 'function') {
			const result = next(action);
			console.log('Новое состояние:', store.getState());
			return result;
		}
	};

const arrayMiddlewares: Middleware[] = [];

if (import.meta.env.VITE_LOGS_REDUX_ENABLE) {
	arrayMiddlewares.push(loggerMiddleware);
}

export const makeStore = () =>
	configureStore({
		reducer: {
			authReducer,
			timeslotsReducer,
			hallmapReducer,
			placesReducer,
			ordersReducer,
			tagsReducer,
			personReducer,
			settingsReducer,
		},
		middleware: getDefaultMiddleware =>
			getDefaultMiddleware({ serializableCheck: false }).concat(
				arrayMiddlewares,
			),
	});

export const store = makeStore();
